export default {"src":"/_next/static/media/polygon.2cd44610.svg","height":14,"width":14};